export enum ENTITY_TYPE {
  DOCUMENT = 'document',
  FOLDER = 'folder',
  /* these may be used at a later date */
  // SECTOIN = 'section',
  // ATTACHMENT = 'attachment'
}
